(function(){
    var amt=document.getElementById('amt'),out=document.getElementById('entries'),lab=document.getElementById('entlab');
    if(!amt||!out||!lab){return;}
    function calc(){
      var v=parseFloat(amt.value)||0, e=v<160?0:Math.floor(v/160);
      out.textContent=e;
      lab.textContent=e===1?'entry from this order':'entries from this order';
      out.style.color=e===0?'#6d6d78':'';
    }
    ['input','change','keyup','blur'].forEach(function(ev){amt.addEventListener(ev,calc);});
    document.querySelectorAll('.tier').forEach(function(tp){tp.addEventListener('click',function(){var a=tp.getAttribute('data-amt');if(a){amt.value=a;calc();}});});
    calc();
  })();

(function(){
    var links=[].slice.call(document.querySelectorAll('.subnav-inner a')), map={};
    links.forEach(function(a){var id=a.getAttribute('href').slice(1),s=document.getElementById(id);if(s)map[id]=a;});
    var obs=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting){links.forEach(function(a){a.classList.remove('active');});var a=map[e.target.id];if(a)a.classList.add('active');}
      });
    },{rootMargin:'-45% 0px -50% 0px',threshold:0});
    Object.keys(map).forEach(function(id){obs.observe(document.getElementById(id));});
  })();

(function(){
    var hb=document.getElementById('hamburger'), sn=document.getElementById('subnav');
    if(!hb||!sn) return;
    function close(){sn.classList.remove('open');hb.innerHTML='☰';hb.setAttribute('aria-expanded','false');}
    hb.addEventListener('click',function(){
      var open=sn.classList.toggle('open');
      hb.innerHTML=open?'✕':'☰';
      hb.setAttribute('aria-expanded',open?'true':'false');
    });
    document.querySelectorAll('a[href^="#"]').forEach(function(a){
      a.addEventListener('click',function(e){
        var el=document.getElementById(a.getAttribute('href').slice(1));
        if(!el) return;
        e.preventDefault(); close();
        requestAnimationFrame(function(){
          var off=document.querySelector('header').offsetHeight;
          var y=el.getBoundingClientRect().top+window.pageYOffset-off-6;
          window.scrollTo({top:y,behavior:'smooth'});
        });
      });
    });
  })();
